"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStandardConcentrationLimitKickouts = exports.getConcentrationLimitKickouts = exports.getNormalizedConcentrationLimit = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const normalizeConcentrationLimit = ({ concentrationLimit, totalConcentrationExposure, }) => Math.min(_.round(common_1.utils.divideByOrZero(concentrationLimit, totalConcentrationExposure), 10), 1);
const getNormalizedConcentrationLimit = ({ concentrationLimitValueType, concentrationLimit, totalConcentrationExposure, }) => {
    switch (concentrationLimitValueType) {
        case 'currency':
        case 'number':
            return normalizeConcentrationLimit({
                concentrationLimit,
                totalConcentrationExposure,
            });
        case 'percentage':
            return concentrationLimit;
        default:
            return (0, common_1.finleyAssertUnreachable)(concentrationLimitValueType);
    }
};
exports.getNormalizedConcentrationLimit = getNormalizedConcentrationLimit;
const getConcentrationLimitKickouts = ({ concentrationFactor, concentrationReceivables, }) => {
    const receivableKickoutMap = {};
    for (const receivable of concentrationReceivables) {
        const { finleyReceivableId, concentrationLimitFields } = receivable;
        const kickout = _.round(concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts *
            concentrationFactor, 10);
        receivableKickoutMap[finleyReceivableId] = kickout;
    }
    return receivableKickoutMap;
};
exports.getConcentrationLimitKickouts = getConcentrationLimitKickouts;
/**
 * For a given concentration limit, identify if any of the servicing tapes
 * exceeded the concentration limit
 *
 * for standard reductions, we take a % based reduction, to equally reduce
 * the borrowing base amount across all concentration receivables
 *
 * @param concentrationLimitReceivables the receivables that the concentration limit applies to
 * @param totalEligibleExposure the total eligible exposure, to find adjustment percentage
 * @param concentrationLimit the concentration limit % of this property
 */
const calculateStandardConcentrationLimitKickouts = ({ concentrationReceivables, totalConcentrationExposure, concentrationLimit, concentrationLimitValueType, }) => {
    const normalizedConcentrationLimit = (0, exports.getNormalizedConcentrationLimit)({
        concentrationLimit,
        concentrationLimitValueType,
        totalConcentrationExposure,
    });
    const concentrationAmount = _.sumBy(concentrationReceivables, ({ concentrationLimitFields }) => concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts);
    const exposureLimit = _.round(totalConcentrationExposure * normalizedConcentrationLimit, 10);
    // We'll multiply each loanTape by the concentration factor to get the
    // updated borrowing base amount
    const concentrationFactor = Math.max(concentrationAmount - exposureLimit, 0) > 0
        ? 1 - common_1.utils.divideByOrZero(exposureLimit, concentrationAmount)
        : 0;
    const kickouts = (0, exports.getConcentrationLimitKickouts)({
        concentrationFactor,
        concentrationReceivables,
    });
    return {
        kickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: normalizedConcentrationLimit,
            concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, totalConcentrationExposure), 10),
        },
    };
};
exports.calculateStandardConcentrationLimitKickouts = calculateStandardConcentrationLimitKickouts;
//# sourceMappingURL=standard.js.map